import {
  acceptanceDateEndPoints,
  acceptanceDateEntities,
  acceptanceDateParamKeys,
} from '../../../../api/acceptanceDateMutation';
import { acceptanceDateUpdateCodes } from '../../../../shared/configs/acceptanceDateUpdateCodes';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { paths } from '../../../../shared/configs/routing';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import { dateFormats, dateTime } from '../../../../shared/packages/dateTime';
import FromBody from './FromBody';
import ToBody from './ToBody';

const metaData = {
  [acceptanceDateEntities.from]: {
    mainFieldName: fieldNames.main.fromDate,
    body: FromBody,
    excludeDateKey: fieldNames.main.toDate,
    title: 'Изменить дату начала',
  },
  [acceptanceDateEntities.to]: {
    mainFieldName: fieldNames.main.toDate,
    body: ToBody,
    excludeDateKey: fieldNames.main.fromDate,
    title: 'Изменить дату окончания',
  },
};

export const getMainFieldName = (entity) =>
  metaData[entity]?.mainFieldName ?? '';

export const getBody = (entity) => metaData[entity]?.body ?? null;

export const getModalTitle = (entity) => metaData[entity]?.title ?? '';

export const getMutateVariablesCreator = (entity) => {
  if (!entity) return () => ({});

  return ({ values, methodName, priorityDate }) => ({
    acceptanceId: values.acceptanceId,
    date: priorityDate || formatDate(values[getMainFieldName(entity)]),
    config: {
      endPoint: acceptanceDateEndPoints[entity][methodName],
      paramKey: acceptanceDateParamKeys[entity],
    },
  });
};

export const createFooterProps = (context) => {
  const {
    closeModal,
    checkDate,
    resetMode,
    toNewConfig,
    changeAndAdd,
    changeAndDelete,
    handleSubmit,
  } = context;

  return new Map([
    [
      0,
      {
        okText: 'Ок',
        cancelText: 'Отмена',
        onCancel: closeModal,
        onOk: handleSubmit(checkDate),
      },
    ],
    [
      acceptanceDateUpdateCodes.allDesksUniquePeriods,
      {
        okText: 'Создать',
        cancelText: 'Отмена',
        onCancel: resetMode,
        onOk: toNewConfig,
      },
    ],
    [
      acceptanceDateUpdateCodes.desksBusy,
      {
        okText: 'Да',
        cancelText: 'Нет',
        onCancel: resetMode,
        onOk: changeAndAdd,
      },
    ],
    [
      acceptanceDateUpdateCodes.outOfAcceptancePeriod,
      {
        okText: 'Да',
        cancelText: 'Нет',
        onCancel: resetMode,
        onOk: changeAndDelete,
      },
    ],
    [
      acceptanceDateUpdateCodes.roomDateShift,
      {
        okText: 'Понятно',
        onOk: closeModal,
      },
    ],
  ]);
};

export const getToNewConfigOptionsCreator =
  (entity, initialDates) => (location, values) => {
    const transformValues = getValuesTransformer(initialDates)[entity];

    return {
      pathname: paths.createNewConfig,
      state: {
        from: {
          location,
          companyId: createCompanyId(location.search),
          excludeDateKey: metaData[entity].excludeDateKey,
          values: transformValues(values),
        },
      },
    };
  };

export const createDefaultValues = (acceptance) => ({
  [fieldNames.main.fromDate]: dateTime(acceptance.fromDate),
  [fieldNames.main.toDate]: dateTime(acceptance.toDate),
  [fieldNames.main.name]: acceptance.name,
  acceptanceId: acceptance.id,
  newConfig: false,
});

function createCompanyId(search) {
  const params = new URLSearchParams(search);
  return Number(params.get(searchParamKeys.company));
}

function formatDate(date) {
  return date.format(dateFormats.ISO);
}

function getValuesTransformer(initialDates) {
  const { fromDate, toDate } = initialDates;
  const { fromDate: fromName, toDate: toName } = fieldNames.main;

  return {
    [acceptanceDateEntities.from]: (values) => ({
      ...values,
      [fromName]: formatDate(values[fromName]),
      [toName]: formatDate(dateTime(fromDate).subtract(1, 'day')),
    }),

    [acceptanceDateEntities.to]: (values) => ({
      ...values,
      [fromName]: formatDate(dateTime(toDate).add(1, 'day')),
      [toName]: formatDate(values[toName]),
    }),
  };
}
